// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"69":"ffc258a5","270":"8e809b5f"}[chunkId] + ".chunk.js";
};